import { discountsSelector, calculateOrderSummary } from 'order-summary'
import { FORM_NAME } from '../constants'
import { createSelector } from 'reselect'

export const getIndividualRegistrationOrderSummary = createSelector(
  (_, props) => props.membershipPlan.price,
  discountsSelector(FORM_NAME),
  (price, discounts) => calculateOrderSummary(price, discounts)
)
